// extracted by mini-css-extract-plugin
module.exports = {"barWrapper":"categoryBar_barWrapper__3bvv6","boxFly":"categoryBar_boxFly__2xIz5","categoryBox":"categoryBar_categoryBox__3jchA","categoryName":"categoryBar_categoryName__3s8as"};